export default "assets/images/logo-3513a80f.svg";